// extracted by mini-css-extract-plugin
export default {"p_tye":"a0c1671fbc","slcted":"ea171a4148","slc_color":"f8ffa67c8c","item_p":"_6f290504e1","r0":"a3dbb91a2f"};